import { useTranslation } from "react-i18next";
import clsx from 'clsx';
import Words from "./Words";

function Hero() {
  const [t] = useTranslation();

  return (
    <div className="h-screen min-h-[600px] flex items-center justify-center text-white">
      <div className="flex flex-col items-center pt-[10vh]">
        <h1 className={clsx(
          '[font-size:45px] leading-[45px] mb-6 font-bold text-center [letter-spacing:-1px]',
          'md:[font-size:66px] md:leading-[66px] md:w-[728px] md:mb-5',
          'lg:[font-size:80px] lg:leading-[80px] lg:w-[904px] lg:mb-6',
          'xl:[font-size:100px] xl:leading-[100px] xl:w-[1100px] xl:mb-3.5',
        )}>
          <Words selection={false}>{t("hero.title")}</Words>
        </h1>
        <h2
          className={clsx(
            '[font-size:26px] leading-[25px] w-[320px] font-semibold text-l text-center',
            'md:[font-size:32px] md:leading-[35px] md:w-[420px]',
            'lg:[font-size:38px] lg:leading-[42px] lg:w-[480px]',
            'xl:[font-size:44px] xl:leading-[48px] xl:w-[540px]',
          )}
        >
          <Words selection={false}>{t('hero.subtitle')}</Words>
        </h2>
      </div>
    </div>
  );
}

export default Hero;
